'use client';

/**
 * 상세 다이얼로그가 연 상품의 상세 — 상품 정보 조사 화면의 상세와 같은 질문 셋(순위·가격 이력 · 다른 판매몰 · 상세페이지)을 그대로 쓴다(`useProductDetail`).
 *
 * 상품 카드를 열었을 때만 묻는다. 상세페이지가 수집되지 않은 상품은 목록 값과 이력만 온다.
 * 카드에 상품 링크가 없으면(이미지 검색의 상품) 찾은 상세의 링크로 채운다 — 상세 수집 막대가 링크를 요구한다.
 * ⚠️ 상품 정보 조사 화면의 훅을 빌려 쓴다 — 두 화면이 같은 상세를 보여야 해서다. 공용 자리로 옮기는 일은 따로 한다.
 */

import { useMemo } from 'react';

import { useProductDetail } from 'src/sections/market/hooks/load/fetch/use-product-detail';

import type { MediaCard } from '../../../utils/search-all-media-cards';

export function useSearchAllProductDetail(card: MediaCard | null) {
  const base = card?.kind === 'product' ? card.product ?? null : null;
  const state = useProductDetail(base, Boolean(base));
  const found = state.detail.data?.found ? state.detail.data : null;
  const product = useMemo(
    () => (base && !base.link && found?.link ? { ...base, link: found.link } : base),
    [base, found?.link],
  );
  return { product, ...state };
}

export type SearchAllProductDetail = ReturnType<typeof useSearchAllProductDetail>;
